<template>
  <information-accordion
    :collapsed="collapsed"
    :sections="sections"

    @toggled="toggled"
  />
</template>

<script>
  import form from '@cordel/helpers/form/mixin';
  import InformationAccordion from '@cordel/components/Information/Accordion.vue';

  export default {
    name: 'CordelFormSummary',
    components: {
      InformationAccordion,
    },
    mixins: [
      form,
    ],
    props: {
      json: {
        type: Object,
        default() {
          return {};
        },
      },
      schemaGenerator: {
        type: Function,
        default() {
          return () => ({});
        },
      },
      payloadGenerator: {
        type: Function,
        default() {
          return () => ({});
        },
      },
      collapsed: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        schema: {},
        payload: {},
      };
    },
    mounted() {
      this.payload = this.payloadGenerator();
      this.schema = this.schemaGenerator();

      this.setJSON(this.payload, this.json);

      this.$emit('initialized');
    },
    methods: {
      toggled(section, boolean) {
        this.$emit('toggled', section, boolean);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';

  .cordel-summary {
  }
</style>
